import { accountIdFormat } from "@redotech/redo-account-id";
import {
  processingSessionIdFormat,
  processingSessionItemIdFormat,
} from "@redotech/redo-return-id";
import * as z from "zod";

const targetAccountId = accountIdFormat.schema.optional();

/** Whether the walked unit's original product has a mapping, picking a map-mode transform's branch. */
export const resolveTransformProductBranch = {
  name: "resolveTransformProductBranch" as const,
  input: z.union([
    z.object({
      sessionItemId: processingSessionItemIdFormat.schema,
      targetAccountId,
    }),
    z.object({
      itemSessionId: processingSessionIdFormat.schema,
      targetAccountId,
    }),
  ]),
  output: z.object({ mapped: z.boolean() }),
};
